import React, { KeyboardEvent } from "react";

import "./Paging.css";

interface IPagingProps {
    selectedPage: number;
    countOfElements: number;
    countOnPages: number;
    onTileClick: (num: number) => void;
}

const Paging = (props: IPagingProps) => {
    const selectPage = (pageNumber: number) => {
        if (pageNumber > 0) props.onTileClick(pageNumber);
    };

    const pageKeyUpPress = (
        event: KeyboardEvent<HTMLSpanElement>,
        pageNumber: number
    ) => {
        if (event.key === "Enter") {
            selectPage(pageNumber);
        }
    };

    const getTiles = () => {
        const tileSkipCount = 3;

        const tilesCount = Math.ceil(
            props.countOfElements / props.countOnPages
        );

        const leftSkipExists = props.selectedPage > tileSkipCount + 2;
        const rightSkipExists =
            props.selectedPage < tilesCount - tileSkipCount - 2;

        const tilesArray: number[] = [];
        tilesArray.push(1);

        if (leftSkipExists) {
            tilesArray.push(0);
            for (
                let i = props.selectedPage - tileSkipCount;
                i < props.selectedPage;
                ++i
            ) {
                tilesArray.push(i);
            }
        } else {
            for (let i = 2; i < props.selectedPage; ++i) {
                tilesArray.push(i);
            }
        }

        if (!tilesArray.includes(props.selectedPage))
            tilesArray.push(props.selectedPage);

        if (rightSkipExists) {
            for (
                let i = props.selectedPage + 1;
                i < props.selectedPage + tileSkipCount;
                ++i
            ) {
                tilesArray.push(i);
            }
            tilesArray.push(0);
        } else {
            for (let i = props.selectedPage + 1; i < tilesCount; ++i) {
                tilesArray.push(i);
            }
        }

        if (!tilesArray.includes(tilesCount)) tilesArray.push(tilesCount);

        return tilesArray.map((num, inx) => {
            if (num === 0) {
                return (
                    <span className="paging-dots" key={`dots-${inx}`} aria-hidden="true">
                        ...
                    </span>
                );
            }

            return (
                <button
                    type="button"
                    className={"paging-tile" + (num === props.selectedPage ? " selected-tile" : "")}
                    key={`p-${num}`}
                    onClick={() => selectPage(num)}
                    onKeyUp={(e) => pageKeyUpPress(e, num)}
                    aria-current={num === props.selectedPage ? "page" : undefined}
                >
                    {num}
                </button>
            );
        });
    };

    if (props.countOfElements > props.countOnPages) {
        return <div className="paging-container">{getTiles()}</div>;
    }
    return <></>;
};

export default Paging;
